exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-custom{width:50%!important}.el-textarea__inner{height:65px!important;min-height:65px!important}.card-body,.card-header+.card-body{border-radius:0}.el-collapse-item__content{padding-bottom:0}.content-body{padding:20px}.el-upload-list__item{max-width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48a992d4","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/documents/invoice_generate.vue
// module id = MgyY
// module chunks = 0